import { render, staticRenderFns } from "./image-library.page.vue?vue&type=template&id=a3392912&scoped=true&"
import script from "./image-library.page.vue?vue&type=script&lang=js&"
export * from "./image-library.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3392912",
  null
  
)

export default component.exports